module.exports = __webpack_public_path__ + "assets/select-code.c039bae6.svg";